import util from "../util";

let controller = "AnaliseCadastro";

export default {
  GetAll: (dto, options) => {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller, dto)
  },
  Reprovar(codigo, dto) {
    return util.Axios.Put(controller + '/Reprovar', codigo, dto)
  },
  Aprovar(dto) {
    return util.Axios.Post(controller + '/Aprovar', dto)
  },
  ReprocessarRetornoAntifraude(id) {
    return util.Axios.Post(controller + `/${id}/Reprocessar-retorno-antifraude`, {})
  }
}
